/**
 * Default API client — authenticated legacy Kubera backend.
 * Public CRM routes: `api/middleware/publicAppsClient.js`
 */
import privateClient from "./api/middleware/privateClient";

export default privateClient;
